// Mapping of URL params to descriptor fields for filtering
// group: the property on the descriptor, key: min/max for range filtering

const paramMap = {
    minArea: { fields: ['area'], key: 'min' },
    maxArea: { fields: ['area'], key: 'max' },
    minWidth: { fields: ['width'], key: 'min' },
    maxWidth: { fields: ['width'], key: 'max' },
    minLength: { fields: ['length'], key: 'min' },
    maxLength: { fields: ['length'], key: 'max' },
    minPrice: { fields: ['stdRate'], key: 'min' },
    maxPrice: { fields: ['stdRate'], key: 'max' },
};

export default paramMap;
